import { useState } from "react";
import { motion } from "framer-motion";
import { X, Plus } from "lucide-react";

export function Modal({ title, subtitle, onClose, children }) {
  return (
    <div className="modal-backdrop" data-testid="modal-backdrop" onClick={onClose}>
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        className="modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-head">
          <div>
            <span className="eyebrow"><span></span> {subtitle || "YENİ KAYIT"}</span>
            <h2>{title}</h2>
          </div>
          <button className="icon-btn" data-testid="modal-close" onClick={onClose}>
            <X size={19} />
          </button>
        </div>
        {children}
      </motion.div>
    </div>
  );
}

export function FormField({ label, children }) {
  return (
    <label className="form-field">
      <span>{label}</span>
      {children}
    </label>
  );
}

export function SubmitButton({ children = "Kaydet", testId = "form-submit" }) {
  return (
    <button className="primary-btn full" type="submit" data-testid={testId}>
      <Plus size={17} /> {children}
    </button>
  );
}

export function useForm(initial) {
  const [form, setForm] = useState(initial);
  const reset = () => setForm(initial);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  return { form, setForm, set, reset };
}

export function EmptyState({ icon: Icon, title, text, actionLabel, onAction, testId = "empty-add-btn" }) {
  return (
    <div className="empty-state">
      {Icon && <Icon size={30} />}
      <b>{title}</b>
      <p>{text}</p>
      {actionLabel && (
        <button className="primary-btn" data-testid={testId} onClick={onAction}>
          <Plus size={16} /> {actionLabel}
        </button>
      )}
    </div>
  );
}

export function PageHeader({ eyebrow, title, subtitle, actions, heroImage, heroTint = "green" }) {
  if (heroImage) {
    return (
      <section className={`page-hero tint-${heroTint}`} data-testid="page-hero">
        <div className="page-hero-img" style={{ backgroundImage: `url(${heroImage})` }} />
        <div className="page-hero-overlay" />
        <div className="page-hero-inner">
          <div>
            {eyebrow && <div className="eyebrow eyebrow-light"><span></span> {eyebrow}</div>}
            <h1>{title}</h1>
            {subtitle && <p>{subtitle}</p>}
          </div>
          {actions && <div className="page-hero-actions">{actions}</div>}
        </div>
      </section>
    );
  }
  return (
    <section className="page-heading">
      <div>
        {eyebrow && <div className="eyebrow"><span></span> {eyebrow}</div>}
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {actions}
    </section>
  );
}

export function StatMini({ label, value, tone = "green", testId }) {
  return (
    <div className={`stat-mini ${tone}`} data-testid={testId}>
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}
